import { useMemo } from 'react';
import { useAllFeatureFlags } from './useFeatureFlag';
import {
  SEGMENT_REVIEW_AUTO_STATES_KEY,
  parseSegmentReviewAutoStates,
} from '../utils/segmentAutoReview';

/** Estados de actuación que dan un tramo por revisado en esta empresa. */
export function useSegmentReviewAutoStates(): string[] {
  const raw = useAllFeatureFlags()[SEGMENT_REVIEW_AUTO_STATES_KEY];
  return useMemo(() => parseSegmentReviewAutoStates(raw), [raw]);
}
